__turbopack_context__.v({
  "headerImage": "Xf1azq_headerImage",
  "logo": "Xf1azq_logo",
  "logoContainer": "Xf1azq_logoContainer",
  "mainTitle": "Xf1azq_mainTitle",
  "pageHeader": "Xf1azq_pageHeader",
  "pageHeaderContent": "Xf1azq_pageHeaderContent",
  "pageHeaderText": "Xf1azq_pageHeaderText",
  "subTitle": "Xf1azq_subTitle",
});
